

import { TrashGallery } from 'components/TrashGallery';

import MainLayout from '../layout/MainLayout';

const TrashPage = () => {
	return (
		<MainLayout title="Trash">
			<TrashGallery />
		</MainLayout>
	);
};

export default TrashPage;
